module.exports = __webpack_public_path__ + "static/media/41.8e2506b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/41.svg
// module id = 2833
// module chunks = 3